var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem from '@wix/ambassador-media-enterprise-public-media-v1-enterprise-item/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var MediaType;
(function (MediaType) {
    MediaType["MIXED"] = "MIXED";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["AUDIO"] = "AUDIO";
    MediaType["DOCUMENT"] = "DOCUMENT";
    MediaType["VECTOR"] = "VECTOR";
    MediaType["ARCHIVE"] = "ARCHIVE";
    MediaType["MODEL3D"] = "MODEL3D";
})(MediaType || (MediaType = {}));
export var PublishStatus;
(function (PublishStatus) {
    PublishStatus["UNDEFINED"] = "UNDEFINED";
    PublishStatus["UNPUBLISHED"] = "UNPUBLISHED";
    PublishStatus["PUBLISHED"] = "PUBLISHED";
    PublishStatus["WIX_ONLY"] = "WIX_ONLY";
})(PublishStatus || (PublishStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _bulkItemUpdateResult = { item: '_enterpriseMediaItem' };
const _bulkUpdateItemRequest = { updateItemRequests: '_updateItemRequest' };
const _bulkUpdateItemResponse = { results: '_bulkItemUpdateResult' };
const _enterpriseMediaItem = { assets: '_itemAssets' };
const _generateFileUploadUrlRequest = {};
const _generateFileUploadUrlResponse = {};
const _getItemRequest = {};
const _getItemResponse = { item: '_enterpriseMediaItem' };
const _importFileRequest = {};
const _importFileResponse = { item: '_enterpriseMediaItem' };
const _itemAssets = {
    image: 'wix.common.Image',
    video: 'wix.common.VideoV2',
    vector: 'wix.common.Image',
    audio: 'wix.common.Audio',
    document: 'wix.common.Document',
    model3d: '_model3D',
};
const _itemUploadCallbackRequest = {};
const _itemUploadCallbackResponse = {};
const _linkItemToCategoriesRequest = {};
const _linkItemToCategoriesResponse = {};
const _model3D = { thumbnail: 'wix.common.Image' };
const _overwriteItemCategoriesRequest = {};
const _overwriteItemCategoriesResponse = {};
const _queryItemsRequest = {};
const _queryItemsResponse = { items: '_enterpriseMediaItem' };
const _searchItemsRequest = {};
const _searchItemsResponse = { items: '_enterpriseMediaItem' };
const _unlinkItemFromCategoriesRequest = {};
const _unlinkItemFromCategoriesResponse = {};
const _updateItemRequest = { item: '_enterpriseMediaItem' };
const _updateItemResponse = { item: '_enterpriseMediaItem' };
/**
 * Internal API called by the public media backend, notify about a file that was created enterprise public media server
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function itemUploadCallback(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            itemId: '$[0].itemId',
            callbackToken: '$[0].callbackToken',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _itemUploadCallbackRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _itemUploadCallbackResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.itemUploadCallback(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Generate an upload url that will make public media to call the enterprise callback endpoint
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function generateFileUploadUrl(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fileName: '$[0].fileName',
            contentType: '$[0].contentType',
            sizeInBytes: '$[0].sizeInBytes',
            categoryIds: '$[0].categoryIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateFileUploadUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateFileUploadUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.generateFileUploadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Import a file using a url
 * @param url - The url to the file to be imported
 * @public
 * @documentationMaturity preview
 * @requiredField url
 * @adminMethod
 */
export function importFile(url, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            url: '$[0]',
            fileName: '$[1].fileName',
            contentType: '$[1].contentType',
            sizeInBytes: '$[1].sizeInBytes',
            categoryIds: '$[1].categoryIds',
            mediaType: '$[1].mediaType',
            uploaderSystemTag: '$[1].uploaderSystemTag',
            uploaderInfoSystemTag: '$[1].uploaderInfoSystemTag',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _importFileRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _importFileResponse,
            depSchemas: { _enterpriseMediaItem, _itemAssets, _model3D },
            fqdnTransformation: {
                paths: [...['item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([url, options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.importFile(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'url',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Search items, all filters only support equality
 * Each query must contain a categoryId filter
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function searchItems(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0].query' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _searchItemsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _searchItemsResponse,
            depSchemas: { _enterpriseMediaItem, _itemAssets, _model3D },
            fqdnTransformation: {
                paths: [...['Array#items']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.searchItems(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Query items allowing to sort by specified fields, all filters only support equality
 * Each query must contain a categoryId filter
 * @public
 * @documentationMaturity preview
 * @permissionId MEDIA.ENTERPRISE_MEDIA_ITEMS_READ
 * @adminMethod
 */
export function queryItems() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.items',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryItemsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryItemsResponse,
        depSchemas: { _enterpriseMediaItem, _itemAssets, _model3D },
        fqdnTransformation: {
            paths: [...['Array#items']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.queryItems(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Update an item
 * @param _id - Id of the item in public media
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField item
 * @adminMethod
 * @returns Updated item info
 */
export function updateItem(_id, item, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            item: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
        };
        const responseTransformation = '$.item';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateItemRequest,
            depSchemas: { _enterpriseMediaItem, _itemAssets, _model3D },
            fqdnTransformation: {
                paths: [...['item']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateItemResponse,
            depSchemas: { _enterpriseMediaItem, _itemAssets, _model3D },
            fqdnTransformation: {
                paths: [...['item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, item, options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.updateItem(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'item',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Bulk update an item
 * @param updateItemRequests - Requests to update individual item
 * @public
 * @documentationMaturity preview
 * @requiredField updateItemRequests
 * @requiredField updateItemRequests.item._id
 * @adminMethod
 */
export function bulkUpdateItem(updateItemRequests, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            updateItemRequests: '$[0]',
            returnEntity: '$[1].returnEntity',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUpdateItemRequest,
            depSchemas: {
                _enterpriseMediaItem,
                _itemAssets,
                _model3D,
                _updateItemRequest,
            },
            fqdnTransformation: {
                paths: [...['Array#updateItemRequests.item']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUpdateItemResponse,
            depSchemas: {
                _bulkItemUpdateResult,
                _enterpriseMediaItem,
                _itemAssets,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([updateItemRequests, options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.bulkUpdateItem(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'updateItemRequests',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get item details
 * @param itemId - Item id
 * @public
 * @documentationMaturity preview
 * @requiredField itemId
 * @adminMethod
 * @returns item info
 */
export function getItem(itemId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { itemId: '$[0]' };
        const responseTransformation = '$.item';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getItemRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getItemResponse,
            depSchemas: { _enterpriseMediaItem, _itemAssets, _model3D },
            fqdnTransformation: {
                paths: [...['item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([itemId]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.getItem(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'itemId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Link the item to multiple categories
 * @param itemId - The item id
 * @public
 * @documentationMaturity preview
 * @requiredField itemId
 * @adminMethod
 */
export function linkItemToCategories(itemId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            itemId: '$[0]',
            categoryIds: '$[1].categoryIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _linkItemToCategoriesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _linkItemToCategoriesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([itemId, options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.linkItemToCategories(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'itemId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Unlink the item from multiple categories
 * @param itemId - The item id
 * @public
 * @documentationMaturity preview
 * @requiredField itemId
 * @adminMethod
 */
export function unlinkItemFromCategories(itemId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            itemId: '$[0]',
            categoryIds: '$[1].categoryIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _unlinkItemFromCategoriesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _unlinkItemFromCategoriesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([itemId, options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.unlinkItemFromCategories(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'itemId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Overwrite item categories
 * @param itemId - The item id
 * @public
 * @documentationMaturity preview
 * @requiredField itemId
 * @adminMethod
 */
export function overwriteItemCategories(itemId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            itemId: '$[0]',
            categoryIds: '$[1].categoryIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _overwriteItemCategoriesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _overwriteItemCategoriesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([itemId, options]);
        const reqOpts = ambassadorWixMediaEnterprisePublicMediaV1EnterpriseItem.overwriteItemCategories(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'itemId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=media-enterprise-public-media-v1-enterprise-item.universal.js.map